const getUserFeatureIds = (user) => {
    if (user.hasOwnProperty("features")) {
        return user.features.map(feature => feature.feature_id);
    } else {
        return []
    }
}

export { getUserFeatureIds };